import { render, staticRenderFns } from "./AddDevice.vue?vue&type=template&id=047f7fab&scoped=true"
import script from "./AddDevice.vue?vue&type=script&lang=js"
export * from "./AddDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047f7fab",
  null
  
)

export default component.exports